import galleryimg from '../assets/images/gallery.png';
import Lightbox from 'react-18-image-lightbox';
import 'react-18-image-lightbox/style.css';
import { useState, useEffect } from "react";
import img4 from '../assets/images/img4.png';
import img5 from '../assets/images/img5.png';
import { useDispatch, useSelector } from "react-redux";
import { getAlbums, getGallery } from '../slices/gallery';
import empty_table from '../assets/images/empty_table.png';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const GalleryMain = () => {
    const { id } = useParams();

    const dispatch = useDispatch();
    const { gallery } = useSelector((state) => state.gallery);

    const {t} = useTranslation();

    const [images, setImages] = useState([]);

    useEffect(() => {
        dispatch(getGallery(id))

    }, []);

    useEffect(() => {
        if (gallery != null) {
            let images1 = [];
            for (let i = 0; i < gallery.gallery.length; i++) {
                images1.push(gallery.gallery[i].image_path);
            }
            setImages(images1);
            console.log(images);
        }
    },[gallery]);
    const [photoIndex, setPhotoindex] = useState(0);
    const [isOpen, setIsopen] = useState(false);

    const openLightbox = (index) => {
        setIsopen(true);
        setPhotoindex(index);
    }

    return (
        <div className="container">
            <section className="mt-5 pt-5 gallery">
                <div className="row">
                    <div className='col-md-12'>
                        <div className='section-title'>
                            <h1><span className='font-color-2'>{gallery?.album.name}</span></h1>
                            {/* <p>{t('section_text1')}<br/>{t('section_text2')}</p> */}
                            <br />
                        </div>
                    </div>

                    {
                        gallery != null ?
                            gallery?.gallery.map((item, index) => {
                                return (
                                    <div className="col-md-3 mb-4 itemBox" key={index} onClick={() => openLightbox(index)}>
                                        <div className="card">
                                            <div className="card-body p-0">
                                                <img src={item.image_path} class="mobile-img"  width={260} height={205} />
                                            </div>
                                            <div className="card-footer post-footer">
                                                <h5 className='mb-0 gallery-title'>{item.name}</h5>
                                                <h6 className='mb-0'>{item.created_at}</h6>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                            :
                            <div className='emptyTable'>
                                <img src={empty_table} />
                                <h5 className='mt-2-new'>No Data Found</h5>
                            </div>
                    }

                </div>

                {isOpen && (
                    <Lightbox
                        mainSrc={images[photoIndex]}
                        nextSrc={images[(photoIndex + 1) % images.length]}
                        prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                        // imageCaption="sfdsfds"
                        enableZoom={false}
                        onCloseRequest={() => setIsopen(false)}
                        onMovePrevRequest={() =>
                            setPhotoindex((photoIndex + images.length - 1) % images.length)
                        }
                        onMoveNextRequest={() =>
                            setPhotoindex((photoIndex + 1) % images.length)
                        }
                    />
                )}

            </section>
        </div>
    );
}
export default GalleryMain;